// 稀有装备
import { EquipMain } from "../equipmentType";
import { equipTypes } from "../equipConst";
import { propertyName, propertyAttr } from "@/const/character";
// 武器池
const equipPoolListW: EquipMain[] = [
  {
    name: "暗淡的黑光",
    describe: "真的有黑色光吗",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.5
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.2
      }
    ],
    grade: 2,
    level: 10,
    icon: 5,
    price: 40
  },
  {
    name: "黑色的光芒",
    describe: "他来了",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 82
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.5
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.2
      }
    ],
    grade: 2,
    level: 15,
    icon: 5,
    price: 80
  },
  {
    name: "猫妖的骨爪",
    describe: "用它肯定能挠出血来",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.4
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 32
      }
    ],
    grade: 2,
    level: 20,
    icon: 19,
    price: 300
  },
  {
    name: "吃光田鸡剑",
    describe: "耀眼的光芒啊",
    type: equipTypes.weapon,
    props: [
      {
        name: propertyName.ATK,
        type: propertyAttr.ATK,
        isPercent: false,
        value: 130
      },
      {
        name: propertyName.AS,
        type: propertyAttr.AS,
        isPercent: false,
        value: 0.5
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 40
      }
    ],
    grade: 2,
    level: 25,
    icon: 27,
    price: 600
  }
];
// 防具池
const equipPoolListA: EquipMain[] = [
  {
    name: "哥布林精英骨架",
    describe: "穿上它挑战哥布林王吧",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 15
      }
    ],
    grade: 2,
    level: 10,
    icon: 12,
    price: 40
  },
  {
    name: "钢铁甲",
    describe: "钢铁守卫",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 100
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: 110
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 10
      }
    ],
    grade: 2,
    level: 15,
    icon: 10,
    price: 80
  },
  {
    name: "龙吟铠甲",
    describe: "真龙出世",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 50
      }
    ],
    grade: 2,
    level: 20,
    icon: 18,
    price: 350
  },
  {
    name: "纳德的斩龙服",
    describe: "我曾穿着它斩下巨龙",
    type: equipTypes.lorica,
    props: [
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 66
      },
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 66
      },
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 66
      }
    ],
    grade: 2,
    level: 24,
    icon: 38,
    price: 700
  }
];
// 首饰池
const equipPoolListJ: EquipMain[] = [
  {
    name: "雪兔之链",
    describe: "听说雪兔很保暖",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 70
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 20
      }
    ],
    grade: 2,
    level: 10,
    icon: 23,
    price: 40
  },
  {
    name: "佛珠",
    describe: "一串佛珠",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 30
      },
      {
        name: propertyName.VIT,
        type: propertyAttr.VIT,
        isPercent: false,
        value: 30
      }
    ],
    grade: 2,
    level: 15,
    icon: 25,
    price: 80
  },
  {
    name: "水之钥",
    describe: "女子柔，如流水",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.DEX,
        type: propertyAttr.DEX,
        isPercent: false,
        value: 50
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: 350
      },
      {
        name: propertyName.CRR,
        type: propertyAttr.CRR,
        isPercent: false,
        value: 0.23
      }
    ],
    grade: 2,
    level: 20,
    icon: 24,
    price: 380
  },
  {
    name: "鬼巫之链",
    describe: "用寿命换力量，阴间玩意",
    type: equipTypes.necklace,
    props: [
      {
        name: propertyName.STR,
        type: propertyAttr.STR,
        isPercent: false,
        value: 130
      },
      {
        name: propertyName.HP,
        type: propertyAttr.HP,
        isPercent: false,
        value: -200
      },
      {
        name: propertyName.DEF,
        type: propertyAttr.DEF,
        isPercent: false,
        value: -100
      }
    ],
    grade: 2,
    level: 25,
    icon: 39,
    price: 580
  }
];

const equipsGrade2: EquipMain[] = [
  ...equipPoolListW,
  ...equipPoolListA,
  ...equipPoolListJ
];
export { equipsGrade2 };
